module.exports = __webpack_public_path__ + "img/pro-xtslider2.30422fde.png";